export default __webpack_public_path__ + "static/media/cus1.6be4e7f2.svg";